module.exports = __webpack_public_path__ + "static/img/title.b318d5c6.png";